export default "__VITE_ASSET__DymG_me___"